import { View } from '@react-pdf/renderer'

import { BookingDetail } from '../../../../../types/bookingDetails'
import { bookerName } from '../../../statement'
import Header from '../Header/index'
import HotelDetail from '../HotelDetail'
import PriceAndName from '../PriceAndName/index'
import QRCodeBox from '../QRCode'
import styles from './styles/RenderParts.styles'

interface RenderPartsProps {
  data: BookingDetail
  masterReservationNumber: string
}

const RenderParts = ({ data, masterReservationNumber }: RenderPartsProps) => {
  return (
    <View style={styles.mainDiv}>
      <View style={styles.header}>
        <Header
          ReservationNumber={data.basicDetails.displayReservationNumber}
          Created={data.basicDetails.createdAt}
        />
      </View>
      <View style={styles.hotelDataAndReserveData}>
        <View style={styles.reserveData}>
          <View style={styles.priceAndName}>
            <PriceAndName
              Currency={data.basicDetails.currency}
              AfterTaxPrice={data.billingSummary.finalAmount}
              RefundAmount={data.billingSummary.refundAmount}
              BookerName={bookerName(data.bookerInfo)}
            />
          </View>
          <View style={styles.hotelDetail}>
            <HotelDetail data={data} />
          </View>
        </View>
        <View style={styles.QRCodePart}>
          <QRCodeBox masterReservationNumber={masterReservationNumber} />
        </View>
      </View>
    </View>
  )
}

export default RenderParts
